import {
  formatAttendeeEligibilityForApi,
  normalizeAttendeeEligibility,
} from '../../../shared/registrationSettings';

export const COMMUNITY_DESCRIPTION_MAX = 300;

export {
  formatAttendeeEligibilityForApi,
  getAttendeeEligibilityLabel,
  normalizeAttendeeEligibility,
} from '../../../shared/registrationSettings';

export const createCommunityEditInitialState = (channel) => ({
  title: channel?.name ?? '',
  description: channel?.description ?? '',
  requireJoinApproval: Boolean(channel?.requireJoinApproval),
  attendeeEligibility: normalizeAttendeeEligibility(channel?.attendeeEligibility),
});

export const buildPartnerGroupChannelUpdatePayload = (form) => ({
  name: String(form?.title ?? '').trim(),
  description: String(form?.description ?? '').trim(),
  attendeeEligibility: formatAttendeeEligibilityForApi(form?.attendeeEligibility),
  requireJoinApproval: Boolean(form?.requireJoinApproval),
});

export const createCommunityCreateInitialState = () => ({
  requireJoinApproval: false,
  attendeeEligibility: normalizeAttendeeEligibility(),
});

export const buildPartnerCommunityCreatePayload = (partnerId, form) => ({
  partnerId: String(partnerId ?? '').trim(),
  requireJoinApproval: Boolean(form?.requireJoinApproval),
  attendeeEligibility: formatAttendeeEligibilityForApi(form?.attendeeEligibility),
});

export const mergePartnerGroupChannelFormIntoChannel = (channel, form) => {
  if (!channel) return channel;

  return {
    ...channel,
    ...buildPartnerGroupChannelUpdatePayload(form),
  };
};
